var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isLoading)?_c('div',{staticClass:"item"},[(!_vm.isFavorite)?_c('span',{staticClass:"button fastic-heart",on:{"click":function($event){return _vm.addToFavorite()}}}):_c('span',{staticClass:"button fastic-heart-full",on:{"click":function($event){return _vm.removeToFavorite()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }